import React, { useState } from 'react';
import { Titled } from 'react-titled';
import { useTranslation } from 'react-i18next';
import AppLayout from 'components/common/AppLayout';
import NoticeLayoutRedesign from 'components/common/NoticeLayoutRedesign';
import { Box, Button, Flex, Spinner, Text } from '@resideo/blueprint-react';
import styled from 'styled-components';
import { PRO_PORTAL_ACCEPT_INVITE_PATH, PRO_PORTAL_URL } from 'config';

const NextButton = styled(Button)`
  width: 325px;

  @media (max-width: ${({ theme }) => theme.breakpoints.small}) {
    width: 262px;
  }
`;

const PartnerInviteSuccess = () => {
  const { t } = useTranslation();
  const inviteToken = new URLSearchParams(location.search).get('invite');

  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = () => {
    setSubmitting(true);

    window.location.href = `${PRO_PORTAL_URL}/${PRO_PORTAL_ACCEPT_INVITE_PATH}?invite=${inviteToken}`;
  };

  return (
    <Titled
      title={title => `${t('signUp.success.partnerInvite.header')} - ${title}`}>
      <AppLayout
        showHeader={false}
        showLeftNav={false}
        showGreyPanel={true}
        showFooter={false}>
        <NoticeLayoutRedesign
          title={t('signUp.success.partnerInvite.header')}
          showFooter={false}>
          <Flex flexDirection='column'>
            <Flex flexDirection='column' alignItems='left' padding='large'>
              <Box maxWidth='px' fontSize='18px'>
                <Text
                  lineHeight='1.25'
                  marginBottom='large'
                  data-test-success-invite-landing-subheader1>
                  {t('signUp.success.partnerInvite.subHeader1')}
                </Text>
              </Box>
            </Flex>
            <Box>
              <Flex paddingBottom='xLarge' justifyContent='center'>
                <NextButton
                  className='common-button primary'
                  variant='primary'
                  type='submit'
                  onClick={handleSubmit}
                  data-test-submit-button>
                  {submitting && (
                    <Spinner
                      aria-label={t('common.saving')}
                      marginX='small'
                      color='white'
                      verticalAlign='text-top'
                    />
                  )}
                  {!submitting && t('common.next')}
                </NextButton>
              </Flex>
            </Box>
          </Flex>
        </NoticeLayoutRedesign>
      </AppLayout>
    </Titled>
  );
};

export default PartnerInviteSuccess;
